import Config from '../configs/Config'
export default {
  post (vm, action, params, listener) {
    this.handleRequstParams(params)

    let requstUrl = Config.baseUrl + action

    let options = {
      'headers': {}
    }
    if (listener.before) {
      options.before = listener.before
    }

    if (listener.progress) {
      options.progress = listener.progress
    }

    let xhr = vm.$http.post(requstUrl, params, options).then((response) => {
      this.handleSuccess(vm, response, listener)
    }).catch((response) => {
      this.handleError(vm, response, listener)
    })
    return xhr
  },
  get (vm, action, params, listener) {
    this.handleRequstParams(params)

    let options = {
      'params': params,
      'headers': {}
    }

    if (listener.before) {
      options.before = listener.before
    }

    if (listener.progress) {
      options.progress = listener.progress
    }

    let requstUrl = Config.baseUrl + action
    let xhr = vm.$http.get(requstUrl, options).then((response) => {
      this.handleSuccess(vm, response, listener)
    }).catch((response) => {
      this.handleError(vm, response, listener)
    })
    return xhr
  },
  handleSuccess (vm, response, listener) {
    if (!listener) {
      return
    }
    if (listener.onResponse) {
      listener.onResponse(response)
      return
    }
    let data = response.data
    if (data) {
      let code = data.code
      // 判断是否有权限
      if (code === 10086) {
        let userInfo = null
        if (localStorage.userInfo) {
          userInfo = JSON.parse(localStorage.userInfo)
        }

        if (userInfo) {
          if (userInfo.loginPath === 'channel') {
            vm.$router.push('/login/channel')
          } else {
            vm.$router.push('/login/cxh')
          }
        } else {
          vm.$router.push('/login/channel')
        }
      }

      if (data.success) {
        if (listener.success) {
          listener.success(data)
        }
      } else {
        this.handleError(vm, response, listener)
      }
    }
  },
  handleRequstParams: function (params) {
    for (var variable in params) {
      if (params.hasOwnProperty(variable)) {
        let value = params[variable]
        if (value == null) {
          delete params[variable]
        }
      }
    }
  },
  handleError (vm, response, listener) {
    if (!listener) {
      return
    }

    if (listener.error) {
      listener.error(response)
    } else {
      let status = response.status
      switch (status) {
        case 200:
          if (response && response.data) {
            vm.$message.error(response.data.errMsg)
          }
          break
        case 0:
          if (navigator.onLine === false) {
            vm.$message.error('网络已断开，请检查网络')
          } else {
            vm.$message.error('无法连接到服务器 ( ⊙ o ⊙ )')
          }
          break
        default:
          // if(status ==null) {
          //   if(response&&response.message) {
          //     vm.$message.error("status==null"+response.message)
          //   }
          // }else{
          //   if(response) {
          //     vm.$message.error("status!=null"+status + ' ' + response.statusText)
          //   }
          // }
      }
    }
  }
}
